<div class="bdo-container re-mb-30 lg:re-mb-60">
  <h3>
    {{ 'documents.title' | translate }}
  </h3>
</div>

<div class="bdo-container--single">
  <div class="re-mb-15 re-bdo-tile">
    <bdo-accountid-with-address></bdo-accountid-with-address>
  </div>

  <!-- show errors on all backend errors -->
  @if (error) {
    <bdo-info-box class="bdo-container--single">{{ error }}</bdo-info-box>
  }

  <form class="bdo-form-container re-mb-10" [attr.aria-label]="'aria.form.documentsFilter' | translate">
    <fieldset name="document-selection" class="re-mb-0">
      <div class="bdo-form-item-container">
        <bdo-dropdown
          [data]="dropdownItems"
          [selected]="dropdownItems[0].value"
          [labelText]="'documents.selectionName' | translate"
          (itemSelected)="updateResults($event)"
        ></bdo-dropdown>
      </div>
    </fieldset>
  </form>
  <div class="bdo-loading__wrapper re-mb-60 md:re-mb-90" [class.bdo-loading__wrapper--height]="isLoading">
    @if (isLoading) {
      <bdo-loading></bdo-loading>
    }
    <div class="bdo-table tablet-up-only">

      <table class="table--desktop">
        <thead>
          <tr>
            <th>{{ 'documents.result.date' | translate }}</th>
            <th>{{ 'documents.result.type' | translate }}</th>
            <th class="re-text-right">{{ 'documents.result.viewHeader' | translate }}</th>
            <th class="re-text-right">{{ 'documents.result.downloadHeader' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (doc of documentData | slice: 0:totalRecords; track doc.data.id) {
            <tr>
              <td class="bdo-font--monospace">{{ doc?.data?.date | date }}</td>
              <td>
                {{ doc?.data?.title }}
              </td>
              <td>
                <button class="document-icon icon__download icon__download--desktop hover-container re-ml-auto re-text-right re-cursor-pointer re-block"
                  [title]="'documents.viewButtonLabel' | translate: {type: doc?.data?.title, date: (doc?.data?.date | date)}"
                  (click)="handleViewDocument($event, doc)">
                  @if (doc.state === DocumentDownloadState.VIEWING) {
                    <div>
                      <div class="in-progress"></div>
                    </div>
                  }
                  @if (doc.state !== DocumentDownloadState.VIEWING) {
                    <svg-icon src="{{ 'documents.img.view' | translate }}"></svg-icon>
                  }
                </button>
              </td>
              <td>
                <button class="document-icon icon__download icon__download--desktop hover-container re-ml-auto re-text-right re-cursor-pointer re-block"
                  [title]="'documents.downloadButtonLabel' | translate: {type: doc?.data?.title, date: (doc?.data?.date | date)}"
                  (click)="handleClickOnDocument($event, doc)">
                  @if (doc.state === DocumentDownloadState.IN_PROGRESS) {
                    <div>
                      <div class="in-progress"></div>
                    </div>
                  }
                  @if (doc.state === DocumentDownloadState.IDLE || doc.state === DocumentDownloadState.SUCCESS || doc.state === DocumentDownloadState.ERROR) {
                    <svg-icon src="{{ 'documents.img.download' | translate }}"
                      >
                    </svg-icon>
                  }
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="mobile-only re-mb-10">
      @for (doc of documentData | slice: 0:totalRecords; track doc.data.id) {
        <div class="re-mb-5">
          <div class="bdo-tile space-line re-mb-2">
            <div class="bold">{{ 'documents.result.date' | translate }}</div>
            <div class="re-mb-15">{{ doc?.data?.date | date }}</div>
            <div class="bold">{{ 'documents.result.type' | translate }}</div>
            <div>{{ doc?.data?.title }}</div>
          </div>
          <div class="bdo-tile re-mb-2">
            <button class="document-icon re-flex-row re-flex bold hover-container re-cursor-pointer" (click)="handleViewDocument($event, doc)">
              {{ 'documents.result.view' | translate }}
              @if (doc.state === DocumentDownloadState.VIEWING) {
                <div>
                  <div class="in-progress"></div>
                </div>
              }
              @if (doc.state !== DocumentDownloadState.VIEWING) {
                <svg-icon src="{{ 'documents.img.view' | translate }}"></svg-icon>
              }
            </button>
          </div>
          <div class="bdo-tile">
            <button class="document-icon re-flex-row re-flex bold hover-container re-cursor-pointer" (click)="handleClickOnDocument($event, doc)">
              {{ 'documents.result.download' | translate }}
              @if (doc.state === DocumentDownloadState.IN_PROGRESS) {
                <div>
                  <div class="in-progress"></div>
                </div>
              }
              @if (doc.state === DocumentDownloadState.IDLE || doc.state === DocumentDownloadState.SUCCESS || doc.state === DocumentDownloadState.ERROR) {
                <svg-icon src="{{ 'documents.img.download' | translate }}"
                  >
                  >
                </svg-icon>
              }
            </button>
          </div>
        </div>
      }
    </div>

    @if (documentData?.length > totalRecords) {
      <bdo-more-button
        class="re-mt-30"
        [label]="'general.action.showMore' | translate"
        (moreEvent)="addRecords(documentData)"
      ></bdo-more-button>
    }

    @if (!isLoading && (!documentData || documentData.length === 0)) {
      <bdo-no-data
        [text]="'documents.noData' | translate">
      </bdo-no-data>
    }

  </div>
</div>

<!-- FAQs -->
<bdo-faqs
  [keyName]="'documents.faqs'"
  [params]="{
              contactLink: reBaseData.hrefContact,
              billingEditLink: 'abschlag/' + customerStore.getAccountId(),
              billExplanationLink: reBaseData.hrefBillExplanation
            }"
></bdo-faqs>
<bdo-poll-frame>
  <bdo-customer-satisfaction-poll />
</bdo-poll-frame>
